import { create } from 'zustand';
import type { RealtimeClientEvent, RealtimeConnectionState } from '@/types/realtime';

interface RealtimeStore {
  connectionState: RealtimeConnectionState;
  failureCount: number;
  lastConnectedAt: string | null;
  lastEventAt: string | null;
  sendEvent: ((event: RealtimeClientEvent) => boolean) | null;
  setConnectionState: (state: RealtimeConnectionState) => void;
  setFailureCount: (count: number) => void;
  setSendEvent: (sender: ((event: RealtimeClientEvent) => boolean) | null) => void;
  sendClientEvent: (event: RealtimeClientEvent) => boolean;
  markConnected: () => void;
  markEventReceived: () => void;
}

export const useRealtimeStore = create<RealtimeStore>((set, get) => ({
  connectionState: 'idle',
  failureCount: 0,
  lastConnectedAt: null,
  lastEventAt: null,
  sendEvent: null,
  setConnectionState: (connectionState) => set({ connectionState }),
  setFailureCount: (failureCount) => set({ failureCount }),
  setSendEvent: (sendEvent) => set({ sendEvent }),
  sendClientEvent: (event) => {
    const sender = get().sendEvent;
    return sender ? sender(event) : false;
  },
  markConnected: () =>
    set({
      connectionState: 'open',
      failureCount: 0,
      lastConnectedAt: new Date().toISOString(),
    }),
  markEventReceived: () => set({ lastEventAt: new Date().toISOString() }),
}));
